import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../api';
import { getToken } from '../utils/token';
import CowLoader from '../components/CowLoader';

export default function VaquitaPreview() {
  const { inviteCode } = useParams();
  const navigate = useNavigate();
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPreview = async () => {
      try {
        const response = await api.get(`/vaquita/preview/${inviteCode}`);
        setPreview(response.data);
      } catch (err) {
        setError(err.response?.data || 'Error al cargar la vista previa');
      } finally {
        setLoading(false);
      }
    };

    fetchPreview();
  }, [inviteCode]);

  const handleJoin = async () => {
    const token = getToken();
    if (!token) {
      // Si no hay token, guardar el código pendiente: el login lo consume
      // automáticamente (une al usuario y lo lleva a la vaquita).
      localStorage.setItem('pendingJoinCode', inviteCode);
      navigate('/');
      return;
    }

    try {
      await api.post(`/vaquita/join/${inviteCode}`);
      navigate(`/vaquita/code/${inviteCode}`);
    } catch (err) {
      const d = err.response?.data;
      const msg = typeof d === 'string' ? d : d?.error || d?.message || err.message || 'Error desconocido';
      if (msg.toLowerCase().includes('ya eres participante') || msg.toLowerCase().includes('already a participant')) {
        navigate(`/vaquita/code/${inviteCode}`);
        return;
      }
      alert('Error al unirse a la vaquita: ' + msg);
    }
  };

  if (loading) return <CowLoader text="Cargando vista previa..." />;
  if (error) return <div className="error">{error}</div>;
  if (!preview) return <div className="not-found">Vaquita no encontrada</div>;

  return (
    <div className="preview-container">
      <div className="preview-card">
        <h1 className="preview-title">🐮 {preview.name}</h1>
        <p className="preview-description">{preview.description || 'Sin descripción'}</p>
        
        <div className="creator-info">
          <span className="creator-label">Creada por:</span>
          <span className="creator-name">🐮 {preview.creatorName}</span>
        </div>

        <div className="join-section">
          <button onClick={handleJoin} className="join-button">
            Unirme a esta vaquita 🐄
          </button>
        </div>
      </div>

      <style jsx>{`
        .preview-container {
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 2rem;
          background: var(--bg-primary);
        }

        .preview-card {
          background: var(--bg-secondary);
          padding: 2rem;
          border-radius: 8px;
          box-shadow: 0 2px 4px var(--shadow-color);
          width: 100%;
          max-width: 600px;
          text-align: center;
        }

        .preview-title {
          color: var(--text-primary);
          font-size: 2rem;
          margin-bottom: 1.5rem;
        }

        .preview-description {
          color: var(--text-secondary);
          margin-bottom: 2rem;
          line-height: 1.6;
        }

        .creator-info {
          background: var(--bg-primary);
          padding: 1rem;
          border-radius: 8px;
          margin-bottom: 2rem;
          display: flex;
          flex-direction: column;
          gap: 0.5rem;
        }

        .creator-label {
          color: var(--text-muted);
          font-size: 0.9rem;
        }

        .creator-name {
          color: var(--text-secondary);
          font-size: 1.1rem;
          font-weight: 500;
        }

        .join-section {
          margin-top: 2rem;
        }

        .join-button {
          background: var(--accent-color);
          color: white;
          border: none;
          padding: 1rem 2rem;
          border-radius: 4px;
          font-size: 1.1rem;
          cursor: pointer;
          transition: background 0.2s;
        }

        .join-button:hover {
          background: var(--accent-hover);
        }

        .loading, .error, .not-found {
          text-align: center;
          padding: 2rem;
          color: var(--text-secondary);
        }

        .error {
          color: var(--danger-color);
        }
      `}</style>
    </div>
  );
} 